<div>
  <div>
    <div class="message-container">
      <p class="welcome-message">{{ moduleName }}</p>
    </div>
  </div>
</div>
